import { useSuspenseQuery } from '@tanstack/react-query';
import type { QueryKey } from '@tanstack/react-query';
import type { QueryConfig } from 'lib/react-query';
import { apiClient } from 'lib/api';
import { isAxiosError } from 'axios';

interface RecordType {
  id: string;
  name: string;
}

export const getNotificationLevel = async (signal?: AbortSignal): Promise<RecordType[]> => {
  const res = await apiClient.get<RecordType[]>(`/notification_levels`, {
    signal,
  });
  if (isAxiosError(res)) {
    const error = new Error('Notification level');
    error.cause = res.response?.data;
    return Promise.reject(error);
  }
  return res.data;
};

interface UseNotificationLevelOptions<TData> {
  config?: QueryConfig<typeof getNotificationLevel, TData>;
}

export const useNotificationLevel = <TData = RecordType[]>({ config }: UseNotificationLevelOptions<TData> = {}) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getNotificationLevel(signal),
    queryKey: ['notification_level'] as QueryKey,
  });
};
